module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/perform.js